<div class="titration-rezept {{partnerName}}">
    <div class="titration-rezept-section" [ngClass]="{'column-view':hasColumnView}">
        <div class="titration-rezept-left">

            <div class="rezept-gelb {{partnerName}}" id="print-rezept-gelb">
                <div class="rezept-gelb-top">
                    <div class="rezept-gelb-left">
                        <div class="rezept-gelb-checkbox mt-4"></div>
                        <div class="rezept-gelb-checkbox mt-1"></div>
                        <div class="rezept-gelb-checkbox mt-1"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                    </div>
                    <div class="rezept-gelb-right">
                        <div class="table-left">
                            <span class="dot-circle">1</span>
                            <div class="rezept-gelb-watermark">MUSTER</div>
                            <table>
                                <tr>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td>
                                        <span></span>
                                        <span></span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <span></span>
                                        <span></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-right">
                            <div class="top-box"></div>
                            <div class="another-boxes">
                                <div class="box"></div>
                                <div class="box"></div>
                                <div class="box"></div>
                                <div class="box"></div>
                            </div>
                            <table>
                                <tr>
                                    <td colspan="3">
                                        <div>
                                            <p>
                                                <span></span>
                                            </p>
                                            <p>
                                                <span></span>
                                                <span></span>
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="rezept-gelb-middle">
                    <div class="rezept-gelb-left">
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                    </div>
                    <div class="rezept-gelb-right">
                        <span class="dot-circle">2</span>
                        <span class="dot-circle">3</span>
                        <div class="rezept-gelb-text">{{rezeptText}}</div>
                    </div>
                </div>
                <div class="rezept-gelb-bottom">
                    <div class="rezept-gelb-left">
                    </div>
                    <div class="rezept-gelb-right">
                        <div class="boxes">
                            <div class="boxes-left">
                                <div class="box"></div>
                                <div class="box"></div>
                            </div>
                            <div class="boxes-right"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-area">
                <div class="form-area-row">
                    <label>Rezeptangaben:</label>
                    <textarea class="form-control" [(ngModel)]="dosierungText" rows="5"></textarea>
                </div>
            </div>
            <div class="form-buttons">
                <div class="button-item" (click)="printRezept()">
                    <img src="/images/private/titration/Musterrezept Drucken.svg" alt="Musterrezept Drucken.svg" />
                    <span>Musterrezept Drucken</span>
                </div>
                <div class="button-item" (click)="copyRezept()">
                    <img src="/images/private/titration/Angaben Kopieren.svg" alt="Angaben Kopieren.svg" />
                    <span>Angaben Kopieren</span>
                </div>
            </div>

        </div>
        <div class="titration-rezept-right">
            <h4>Erforderliche Angaben bei der Verschreibung von Cannabisarzneimitteln.</h4>
            <ul>
                <li><span class="dot-circle">1</span>Versicherung, Name, Geburtsdatum und Adresse des/der Patienten:in.</li>
                <li><span class="dot-circle">2</span>Eindeutige Bezeichnung des Cannabisarzneimittels, der Verordnungsmenge und Angaben zur Dosierung. Der Hinweis auf das Vorliegen einer schriftlichen Gebrauchsanweisung wie „gemäß schriftlicher Anweisung” (&gt;&gt;Dj&lt;&lt;) ist ebenfalls möglich.</li>
                <li><span class="dot-circle">3</span>Angaben des Arztes und Arztstempel.</li>
            </ul>

            <p><strong>Hinweis:</strong> Ihre Praxissoftware muss auf dem neuesten Stand sein, um Cannabisarzneimittel als E-Rezept verordnen zu können.</p>
        </div>
    </div>
</div>
